import { rtLogService } from '@rammetec/core'
import { useSystemApiWsClient } from '@syscolect/application'
import { useEffect } from 'react'
import { monitoringStore } from './monitoring.bootstrap'

const MONITOR_CONNECT_COMMANDS = new Set([
  'monitor:connect',
  'monitor:start',
  'connectMonitor',
  'startMonitor',
])

export function useMonitorRemoteCommands(): void {
  const wsClient = useSystemApiWsClient()

  useEffect(() => {
    if (!wsClient) return

    return wsClient.onControl('remoteCommand', (payload) => {
      const command = payload?.command as string | undefined
      if (!command || !MONITOR_CONNECT_COMMANDS.has(command)) return

      rtLogService.info('[monitoring.bootstrap] remote monitor connect command received', { command })
      void monitoringStore.connect()
    })
  }, [wsClient])
}
